import Banner from "../components/banner";

const customLeadsTexts = {
    "order-dev": {
        "intro": "Опишите идею веб или мобильного приложения и оставьте свои контакты",
        "outro": "Спасибо! Мы с Вами свяжемся",
        "area-placeholder": "Ваша идея"
    },
    "corporate-blog": {
        "intro": "Оставьте свои контакты, чтобы мы могли с Вами связаться",
        "outro": "Спасибо! Мы с Вами свяжемся",
        "area-placeholder": "Какие-то вопросы?"
    }
};

function initOrderDev(element) {
    if (!Banner.popup) {
        Banner.popup = Banner.initPopup();
    }

    const leadTextKey = element.dataset.customLeadText || "order-dev";
    const leadTexts = customLeadsTexts[leadTextKey];

    element.addEventListener("click", (event) => {
        if (!event.isTrusted || !Banner.popup || !leadTexts) {
            return;
        }

        for (const key of ["intro", "area-placeholder"]) {
            Banner.popup.element.querySelectorAll(`[data-key="${key}"]`)
                .forEach(item => item.textContent = leadTexts[key]);
        }

        Banner.popup.form.dataset.bid = element.dataset.orderDev;
        Banner.popup.form.dataset.outro = leadTexts.outro;
        Banner.popup.popup.open();
    });
}

function init() {
    document.querySelectorAll("[data-order-dev]")
        .forEach(element => initOrderDev(element));
}

export {
    init as initCustomLeads
};
